// extracted by mini-css-extract-plugin
export default {"cart":"CartContent_cart__0D87b","cart__title":"CartContent_cart__title__foVRd","cart__link":"CartContent_cart__link__swWG3"};